goog.declareModuleId('yext.ui.lib.usekeydown');

/**
 * @param {string} targetKey
 * @param {function():void} callback
 */
export function useKeyDown(targetKey, callback) {
  React.useEffect(
    // Add event listeners
    () => {
      const downHandler = ({key}) => {
        if (key === targetKey) {
          callback();
        }
      };

      window.addEventListener('keydown', downHandler);

      // Remove event listeners on cleanup
      return () => {
        window.removeEventListener('keydown', downHandler);
      };
    },
    [targetKey, callback],
  );
}
